<template>
  <b-row class="proprietes-jeu mx-0" :class="{ 'jeu-ced mr-xl-3 mt-xl-0 mb-xl-3': idFamille }">
    <b-col
      class="d-flex text-center mt-1 mt-md-0 px-md-4 overflow-auto"
      order-md="2"
      cols="12"
      :class="$mq == 'xs' ? 'info-mobile' : 'info px-2'"
    >
      <div class="bloc-info">
        <div class="titre-info">{{ $t('messageComponent.miseMin') }}</div>
        <div>
          {{ getFormatMontant(produit.betLimits ? produit.betLimits.CAD.min : produit.miseMin) }}
        </div>
      </div>
      <div class="bloc-info">
        <div class="titre-info">{{ $t('messageComponent.miseMax') }}</div>
        <div>
          {{ getFormatMontant(produit.betLimits ? produit.betLimits.CAD.max : produit.miseMax) }}
        </div>
      </div>
      <div v-if="produit.nbLigne > 0" class="bloc-info">
        <div class="titre-info">{{ $t('messageComponent.lignes') }}</div>
        <div>{{ produit.nbLigne }}</div>
      </div>
      <div v-if="produit.mntGrosLot" class="bloc-info">
        <div class="titre-info">{{ $t('messageComponent.gainMaximum') }}</div>
        <div>{{ getFormatMontant(produit.mntGrosLot) }}</div>
      </div>
      <div v-if="produit.dealer" class="bloc-info">
        <div class="titre-info">{{ $t('messageComponent.presentateur') }}</div>
        <div>{{ produit.dealer.name }}</div>
      </div>
      <div v-if="langueI18n" class="bloc-info">
        <div class="titre-info">{{ $tc('langue', langue == 'fren' ? 2 : 1) }}</div>
        <div class="text-uppercase">{{ langueI18n }}</div>
      </div>
    </b-col>
    <b-col
      class="titreJeu graphik_black mb-2 mb-md-1 mt-md-3 px-2 px-md-4"
      order-md="1"
      cols="12"
      v-html="mixinProduitCasino_getTitre()"
    />
    <b-col
      v-if="produit.titreMarketing"
      class="titre-marketing graphik_black col-12 col-md-7 mb-2 mt-md-2 mb-md-3 px-2 px-md-4"
      order-md="3"
      v-html="produit.titreMarketing"
    />
    <b-col
      v-if="produit.description"
      class="col-12 col-md-7 px-2 px-md-4"
      :class="{ 'col-md-7': idFamille }"
      order-md="3"
    >
      <div class="description texteListe mb-2" v-html="contentDescription"></div>
      <div
        v-if="produit.description.length > 270"
        class="plus graphik_medium mb-3 mb-md-0"
        @click="descriptionOuvert = !descriptionOuvert"
      >
        {{
          descriptionOuvert
            ? $t('messageComponent.enSavoirMoins')
            : $t('messageComponent.enSavoirPlus')
        }}
      </div>
    </b-col>
    <b-col
      v-if="listeEtiquette.length > 0"
      class="col-12 px-0 px-md-4"
      :class="{ 'col-md-5': produit.description }"
      order-md="5"
    >
      <div class="caracteristiques px-2">
        {{ $t('messageComponent.caracteristiques') }}
      </div>
      <div class="liste-boutons-collections d-flex overflow-auto py-1 px-2 pl-1">
        <b-button
          v-for="etiquette in listeEtiquette"
          :key="etiquette['@id']"
          pill
          class="mb-1 mr-1 px-2 py-1"
          v-bind="jel_getLienBinding(getLienCollection(etiquette))"
        >
          {{ etiquette.titre }}
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex';

import mixinProduitCasino from '@/mixins/casino/mixinProduitCasino';
import { formatMontant } from '@/helpers/StringHelpers';

export default {
  name: 'JeuCasinoPropriete',
  mixins: [mixinProduitCasino],
  props: {
    produit: { type: Object, required: true },
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          caracteristiques: 'Caractéristiques',
          miseMin: 'Mise min.',
          miseMax: 'Mise max.',
          lignes: 'Lignes',
          gainMaximum: 'Gain maximum',
          presentateur: 'Présentateur',
          langue: {
            al: null,
            ar: 'ara',
            b5: null,
            bg: 'bul',
            bp: null,
            ca: 'cat',
            cn: null,
            cs: 'cze',
            de: 'ger',
            dk: 'dan',
            el: 'gre',
            en: 'eng',
            es: 'spa',
            et: 'est',
            fi: 'fin',
            fl: null,
            fr: 'fra',
            he: 'heb',
            hr: 'scr',
            hu: 'hun',
            hy: 'arm',
            id: 'ind',
            it: 'ita',
            ja: 'jpn',
            ka: 'geo',
            ko: 'kor',
            lt: 'lit',
            nl: 'dut',
            no: 'nor',
            pl: 'pol',
            pt: 'por',
            ro: 'rum',
            ru: 'rus',
            sk: 'slo',
            sl: 'slv',
            sr: 'scc',
            sv: 'swe',
            th: 'tha',
            tr: 'tur',
            vi: 'vie',
            fren: 'fra/eng',
          },
          enSavoirPlus: 'En savoir plus',
          enSavoirMoins: 'En voir moins',
        },
      },
      en: {
        messageComponent: {
          caracteristiques: 'Characteristics',
          miseMin: 'Min. bet',
          miseMax: 'Max. bet',
          lignes: 'Lines',
          gainMaximum: 'Maximum win',
          presentateur: 'Gaming host',
          langue: {
            al: null,
            ar: 'ara',
            b5: null,
            bg: 'bul',
            bp: null,
            ca: 'cat',
            cn: null,
            cs: 'cze',
            de: 'ger',
            dk: 'dan',
            el: 'gre',
            en: 'eng',
            es: 'spa',
            et: 'est',
            fi: 'fin',
            fl: null,
            fr: 'fra',
            he: 'heb',
            hr: 'scr',
            hu: 'hun',
            hy: 'arm',
            id: 'ind',
            it: 'ita',
            ja: 'jpn',
            ka: 'geo',
            ko: 'kor',
            lt: 'lit',
            nl: 'dut',
            no: 'nor',
            pl: 'pol',
            pt: 'por',
            ro: 'rum',
            ru: 'rus',
            sk: 'slo',
            sl: 'slv',
            sr: 'scc',
            sv: 'swe',
            th: 'tha',
            tr: 'tur',
            vi: 'vie',
            fren: 'fra/eng',
          },
          enSavoirPlus: 'Read more',
          enSavoirMoins: 'See less',
        },
      },
    },
  },
  data() {
    return {
      descriptionOuvert: false,
    };
  },
  computed: {
    ...mapGetters({
      produitCollectionGetUuidByName: 'produitCollection/getUuidByName',
      etiquetteGetByUuid: 'etiquette/getByUuid',
    }),
    idFamille() {
      // Si on a 2 paramètres (famille/produit) alors on a une famille (CED)
      return this.$route.params.param2 ? this.$route.params.param1 : null;
    },
    listeEtiquette() {
      const filtreListeEtiquette = [];
      if (this.produit.listeEtiquette) {
        this.produit.listeEtiquette['@nodes'].forEach((item) => {
          const etiquette = this.etiquetteGetByUuid(this.produit.listeEtiquette[item].etiquette);
          if (etiquette && this.produitCollectionGetUuidByName(etiquette.name))
            filtreListeEtiquette.push(etiquette);
        });
      }
      return filtreListeEtiquette;
    },
    langue() {
      if (this.idFamille) {
        return this.produit.language;
      }
      return this.$isMobile() ? this.produit.langueMobile : this.produit.langueInternet;
    },
    langueI18n() {
      return this.langue ? this.$i18n.t(`messageComponent.langue.${this.langue}`) : null;
    },
    contentDescription() {
      return this.descriptionOuvert || this.produit.description.length <= 270
        ? this.produit.description
        : `${this.produit.description.match(/(\s|\S){1,270}(\s|$)/g)[0]}...`;
    },
  },
  methods: {
    getLienCollection(etiquette) {
      const idProduitCollection = this.produitCollectionGetUuidByName(etiquette.name);
      if (idProduitCollection) {
        return {
          field: 'lienInterneCasinoCollection',
          idProduitCollection,
        };
      }
      return null;
    },
    getFormatMontant(montant) {
      return formatMontant(montant);
    },
  },
};
</script>

<style lang="scss" scoped>
.proprietes-jeu {
  color: $noir-casino;
}
.titreJeu {
  font-size: 1.75rem;
  line-height: 2rem;
}
.info-mobile {
  white-space: nowrap;
  > div {
    flex: none;
    margin-left: -1px;
    div:last-child {
      font-family: graphik_bold;
      font-size: 0.8125rem;
    }
  }
}

.info {
  flex-wrap: wrap;
  overflow: auto;
  > div {
    flex: none;
    margin-left: -1px;
    div:last-child {
      font-family: graphik_bold;
      font-size: 0.8125rem;
    }
  }
}
.bloc-info {
  border-left: 1px solid $gris-pale-casino;
  &:last-child {
    border-right: 1px solid $gris-pale-casino;
  }
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  @include media-breakpoint-up(md) {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
.titre-info {
  text-transform: uppercase;
  font-size: 0.75rem;
  color: $gris-fonce-casino;
  opacity: 0.7;
}

.description {
  font-size: 0.9375rem;
  line-height: 1.25rem;

  :last-child {
    padding-bottom: 0px;
    margin-bottom: 0px;
  }
}

.plus {
  font-size: 0.9375rem;
  line-height: 1.25rem;
  text-decoration: underline;
  color: $gris-casino;
  cursor: pointer;
}

.caracteristiques {
  text-transform: uppercase;
  font-size: 0.8125rem;
  line-height: 0.9375rem;
  color: $noir-casino;
  opacity: 0.75;
}

.overflow-auto {
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

::v-deep .texteListe > ul {
  margin-left: 16px;

  @include media-breakpoint-up(xl) {
    margin-left: 16px;
  }

  @include media-breakpoint-down(md) {
    margin-left: 8px;
  }

  li:before {
    content: '';
  }
  li {
    margin-bottom: 24px;

    @include media-breakpoint-up(xl) {
      padding-left: 4px !important;
    }
  }
}

.titre-marketing {
  font-size: 1.125rem;
  line-height: 1.375rem;
}
.liste-boutons-collections {
  white-space: nowrap;
  display: block;
}

@include media-breakpoint-up(md) {
  .titre-marketing {
    font-size: 1.25rem;
    line-height: 1.5rem;
  }
  .liste-boutons-collections {
    flex-wrap: wrap;
    align-content: flex-start;
  }
  .info {
    > div {
      div:last-child {
        font-size: 0.9375rem;
      }
    }
  }
  .titre-info {
    font-size: 0.8125rem;
  }
}
@include media-breakpoint-up(xl) {
  .titreJeu {
    font-size: 2rem;
    line-height: 2.125rem;
  }
  .jeu-ced .info {
    flex-wrap: wrap;
    row-gap: 1rem;
  }
}
</style>
